import * as React from 'react';
import {
    PageSection,
    PageSectionVariants,
    Text,
    TextContent,
    Title,
} from '@patternfly/react-core';
import {ArrowIcon} from "@patternfly/react-icons";
import { Page} from "@keycloak/keycloak-account-ui";
import { useTranslation } from "react-i18next";

export function ContactUsPage(): React.ReactNode {
    const { t } = useTranslation();
    return <Page title={t("contactUsTitle")} description={t("contactUsIntroMessage")}>
        <PageSection padding={{ default: "noPadding" }} variant={PageSectionVariants.light}>
            <TextContent>
                <Title size="xl" headingLevel="h2">
                    {t("contactUsHeading")}
                </Title>
                <Text>
                    <Text
                        component="a"
                        target="_blank"
                        rel="noreferrer noopener"
                        href={t('contactPageHref')}
                    >
                        {t("goToContactPage")}&nbsp;<ArrowIcon />
                    </Text>
                </Text>
            </TextContent>
        </PageSection>
    </Page>
}